import React, { useState, useEffect, useCallback, useContext } from 'react';
import _ from 'lodash';
import { withIntl, IntlContext } from '@jutro/locale';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { useAuthentication} from 'gw-digital-auth-react';
import metadata from './ClaimFileUpload.metadata.json5';
import messages from './ClaimFileUpload.messages';
import styles from './ClaimFileUpload.module.scss';
import { GatewayClaimService } from 'gw-capability-ri-claim';
import { useLocation, useHistory, withRouter  } from 'react-router-dom';

const POLICY_NUMBER = 'policyNumber', 
      CLAIM_NUMBER = 'claimNumber';

const ClaimFileUpload = () => {

    const { authHeader } = useAuthentication();
    const [history, setHistory] = useState(useHistory());
    const location = useLocation();    
    const { clmNo, polNo, dateOfLoss } = location.state === undefined ? {} : location.state;   
    const [policyNumber, setPolicyNumber] = useState(polNo);
    const [claimNumber, setClaimNumber] = useState(clmNo);   
    const [description, setDescription] = useState('');
    const [docTypeList, setDocTypeList] = useState([]);
    const [file, setFile] = useState({});    
    const [fileHistoryList, setFileHistoryList] = useState([]);
    const [isAlert, setIsAlert] = useState(false);
    const [isLoading, setLoadingState] = useState(false);    
    const [isPreview, setIsPreview] = useState(false);    
    const [isSuccess, setIsSuccess] = useState(false);
    const [selectedDocType, setSelectedDocType] = useState({});
    const [uploadButtonValue, setUploadButtonValue] = useState('');
    const intl = useContext(IntlContext);

    useEffect(() => {     
        getDocTypes();
        persistValueWithLocalStorage();   
        
        let pol = policyNumber;
        if(!policyNumber){
            pol = window.localStorage.getItem(POLICY_NUMBER);
            setPolicyNumber(pol);            
        }        
        getUploadHistory(pol);
    }, []);

    useEffect(() => { 
        if(polNo){
            window.localStorage.setItem(POLICY_NUMBER,polNo);
        }
        if(clmNo){
            window.localStorage.setItem(CLAIM_NUMBER,clmNo);
        }
    });

    const descriptionValueChange = useCallback(value =>{
        setDescription(value);
    });

    const docTypeValueChangeFn = (value) => {        
        setIsSuccess(false);
        const selected = docTypeList.filter(item => item.code === value).pop();
        setDescription(selected.name);
        setSelectedDocType(selected === undefined ? {} : selected); 
        if(selected !== undefined){
            setIsAlert(false);
        }else if(isPreview){
            setIsAlert(true);
        }       
    };

    const doUpload = useCallback(() => {
        uploadFile();
        init();
        setFile({}); 
    });

    const getBackToPreviousState = () => {             
        history.push('/ri-claims/tile/open');
    };

    const getDate = (item, index, property) => {        
        const fieldValue = item[property.path];
        let date = "";
        if(fieldValue){
            const dateFormat = require('dateformat')
            date = intl.formatDate(new Date(fieldValue), { year: 'numeric', month: 'short', day: 'numeric' }) + " " + intl.formatTime(new Date(fieldValue));
            //date = dateFormat(new Date(fieldValue), "mmm d, yyyy, hh:mm TT");
        }
        return date;
    };

    const getTypeDescription = (item, index, property) => {        
        const fieldValue = item[property.path];
        let description = docTypeList.filter(docType => docType.code === fieldValue).pop();
        return description ? description.name : '';
    };


    const getDocTypes = () => {
        setLoadingState(true);
        
        GatewayClaimService.getDocTypes(authHeader)
          .then((response) => {           
              setDocTypesForDropdown(response);
          })
          .catch(({ error = {} }) => {
              alert(`error getting  doc types :${error}`);     
          })
          .finally(() => {
              setLoadingState(false);
          });
  
      };

      const getUploadHistory = (policy) => {
        setLoadingState(true);
        
        GatewayClaimService.getFileUploadHistory(policy, authHeader)
          .then((response) => {                 
            setFileHistoryList(response);
          })
          .catch(({ error = {} }) => {  
            alert(`error getting upload history :${error}`);                   
          })
          .finally(() => {
              setLoadingState(false);
          });
  
    };
    
    const handleCancel = () =>{   
        init();     
        setFile({});        
    };

    const init = () => {
        setIsPreview(false);
        setIsSuccess(false);
        setIsAlert(false) 
        setDescription('');
        setSelectedDocType({});
        setUploadButtonValue('');
    };

    const persistValueWithLocalStorage = () =>{ 
        if(!policyNumber && !polNo){
            setPolicyNumber(window.localStorage.getItem(POLICY_NUMBER));
        } 
        else if (policyNumber) {
            setPolicyNumber(policyNumber);
        } 
        else if (polNo) {
            setPolicyNumber(polNo);
        }
    
        if(!claimNumber && !clmNo){
            setClaimNumber(window.localStorage.getItem(CLAIM_NUMBER));
        } 
        else if (clmNo) {
            setClaimNumber(clmNo);
        } 
        else if (claimNumber) { 
            setClaimNumber(claimNumber);
        }
    }

    const previewUpload = useCallback((file ) => {
        setUploadButtonValue(`${file.name} ,Size: ${file.size} Bytes`);
        if(selectedDocType.code === undefined){
            setIsAlert(true)                        
        }
        
        setFile(file)
        setIsPreview(true);
        setIsSuccess(false);
        
    });

    const setDocTypesForDropdown = useCallback((response) => {
        const docTypes = [];
        response.filter(item => item.displayName !== '5020 (Employer 1st Report)')
        .forEach(item =>docTypes.push({code:item.doctype, name:item.displayName}));                
        setDocTypeList(docTypes);
    });

    const uploadFile = async() => {
        setLoadingState(true);
 
        const formData = new FormData();        
        formData.append("description",description);
        formData.append("policy",policyNumber);
        formData.append("claim",claimNumber);
        formData.append("doctype",selectedDocType.code);
        formData.append("file",file);        
        
        await GatewayClaimService.uploadFile(formData, authHeader)
          .then((response) => {     
            setIsSuccess(true);
            getUploadHistory(policyNumber);
          })
          .catch(({ error = {} }) => { 
            alert(`error upload file: ${error}`);
          })
          .finally(() => {
              setLoadingState(false);
          });
  
    };    

    const overrideProps = {
        formLoader: {
            loaded: !isLoading
        },
        dropdown: {
            availableValues: docTypeList,
            value: selectedDocType.code
        },
        fileUploadHistoryTable: {          
            visible: !isLoading,  
            data: fileHistoryList
        },
        descriptionText: {
            value: description,
            visible: isPreview
        },
        buttonContainer:{
            visible: isPreview && !isAlert
        },
        inlineNnotification:{
            visible: isAlert || isSuccess,
            type: isAlert ? 'error' : 'success',
            message: isAlert ? 'Please select the Document Type!' : 'File successfully uploaded!',
        },
        file_uploader: {
            value: uploadButtonValue
        },
        tabadminTitleText: {
            "content": "Claim File Upload (" + claimNumber + ")"
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            descriptionValueChange,
            docTypeValueChangeFn,
            doUpload,           
            getBackToPreviousState,
            getDate,            
            getDocTypes,
            getTypeDescription,
            getUploadHistory,
            handleCancel,
            init,
            persistValueWithLocalStorage, 
            previewUpload,
            setDocTypesForDropdown,
            uploadFile
        }
    };
	
    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
};

export default withRouter(withIntl(ClaimFileUpload));